<template>
    //sections
      <div class="max-w-3xl mx-auto mt-16 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md">
    
        <!-- About Me Section -->
        <div class="mb-8">
    
          <h2 class="text-2xl font-semibold mb-4">About Me</h2>
    
          <p class="text-base">
    
            Dedicated and innovative junior software developer with a passion for building
            and maintaining applications. Skilled in some frontend languages, like
            JavaScript, Vue.js and PHP for backend. Seeking to take part and contribute in
            any dynamic software development team.

          </p>
    
        </div>
    
      </div>
    
      <div class="max-w-3xl mx-auto mt-10 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md">
    
        <!-- Skills Section -->
        <div class="mb-8">
    
          <h3 class="text-xl font-semibold mb-4">Skills</h3>
    
          <ul class="list-disc ml-8">
    
            <li>PHP(Laravel)</li>
    
            <li>Vue.js</li>
    
            <li>Javascript</li>
    
            <li>HTML</li>
    
            <li>CSS</li>
    
            <li>Communication</li>
    
          </ul>
    
        </div>
    
      </div>
    
      <div class="max-w-3xl mx-auto mt-10 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md">
    
        <!-- Experience Section -->
        <div class="mb-8">
    
          <h3 class="text-xl font-semibold mb-4">Experience</h3>
    
          <!-- Job -->
          <div class="mb-4">
    
            <h4 class="text-lg font-semibold mb-2">January 2024 – Present : Frontend Developer</h4>
    
            <ul class="list-disc ml-8">
    
              <li>Worked as an intern frontend developer at Benkiko Dao which is a crypto currency tradding website where I was responsible to create the frontend of their website.</li>
    
            </ul>
    
          </div>
    
        </div>

    </div>
    
    
      <div class="max-w-3xl mx-auto mt-10 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md">
    
        <!-- Education Section -->
        <div class="mb-8">
    
          <h3 class="text-xl font-semibold mb-4">Education</h3>
    
          <p class="text-base">Year:2019 - 2022</p><br>
    
            <b>St.Faustina Mweiga High School,Nyeri,Mweiga</b><br>
          

            Graduated in 2022<br>
    
        </div>
    
      </div>
    
    
      <!-- <div class="max-w-3xl mx-auto mt-10 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md"> -->
    
        <!-- Certifications Section
        <div class="mb-8">
    
          <h3 class="text-xl font-semibold mb-4">Certifications</h3>
    
          <p class="text-base">1. Data Analysis using Python <br>
    
            2. Data Science <br>
    
            3. Introduction to Databases and SQL Querying. <br>
    
            4. Project Management and Business Analytics</p>
    
        </div> -->
    
      <!-- </div> -->
    
      <div class="max-w-3xl mx-auto mt-10 mb-4 px-4 py-8 border bg-white border-gray-300 shadow-md">
    
        <!-- Contact Section -->
        <div>
    
          <h3 class="text-xl font-semibold mb-6">Contact</h3>
    
          <p class="text-base">Feel free to reach out to me for collaboration opportunities or to discuss how I can contribute to your projects through these channels: <br></p>
    
          <p class="m-2 "><a href="davidwagura83@gmail.com" class="text-blue-500">Email</a></p>

          <p class="m-2">Phone number: 0796758548</p>

        </div>
    
      </div>
    
    </template>
    
    <script>
    export default {
      name: 'AboutPage',
    };
    </script>